import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	standalone: true,
	name: 'formatterNumerosLotsFournisseurs'
})
export class FormatterNumerosLotsFournisseursPipe implements PipeTransform {

	transform(dlcsFournisseurs: any, args?: any): string {
		return dlcsFournisseurs ? dlcsFournisseurs.replace(/,/g, ', ') : '';
	}

}
